/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Pickup_QrInputs */

const vi_order_action_pickup_qr = /** @type {(inputs: Order_Action_Pickup_QrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét QR nhận đơn`)
};

/**

* @param {Order_Action_Pickup_QrInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_pickup_qr = /** @type {((inputs?: Order_Action_Pickup_QrInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Pickup_QrInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_pickup_qr(inputs)
});